import React, {createRef, useState} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import MaterialTable from "@material-table/core";
import { TablePagination, Select, MenuItem, useTheme } from "@material-ui/core";
import { ValidatorColumn, ColumnWidth } from "../../../blocks/ColumnHelper";
import SageLedgerCodeMappingsValidator from "../validators/SageLedgerCodeMappingsValidator";

import { useSageLedgerCodeMappings, useAddSageLedgerCodeMapping, useUpdateSageLedgerCodeMapping, useDeleteSageLedgerCodeMapping } from "../../../services/accounts";
import { 
  MaskedText,
} from "../../../controls";
import { defaultComponents } from '../../../controls/Material-Table-Components';


const SageLedgerCodeMappingList = (_props) => {
  const theme = useTheme();
  const {isAuthenticated} = useAuth0();
  const validatorColumn = ValidatorColumn(SageLedgerCodeMappingsValidator, true);

  const props = {
    ..._props
  }
  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  const tableRef = createRef({state: {lastEditingRow: false}});

  const handleAddSageLedgerCodeMapping = useAddSageLedgerCodeMapping();
  const handleUpdateSageLedgerCodeMapping = useUpdateSageLedgerCodeMapping();
  const handleDeleteSageLedgerCodeMapping = useDeleteSageLedgerCodeMapping();

  const queryClient = useQueryClient();
  const extraKeys = [props.record.sageLedgerCodeUuid];

  const sageLedgerCodeMappings = useSageLedgerCodeMappings({tableRef, queryClient, extraKeys});

  const getColumns = (props) => { 

    const baseColumn = {
      cellStyle: { fontSize:14, padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: props.canEdit ? "always" : "never",
      emptyValue: "",
      initialEditValue: "",
    };
    const formatChars={ 
      "U": "[A-Z]", 
      "A": "[A-Z0-9]", 
      "a": "[A-Za-z0-9]",
      "i": "[A-Za-z0-9\\-]",
      "9": "[0-9]",
      "D": "[0-9.]",
      "-": "-",
      "x": "."
    }
    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    return [
      {...validatorColumn},
      /*
        Can use ...ColumnWidth(70) to generate a fixed width column
      */

      {
        ...baseColumn,
        ...(ColumnWidth(140, undefined, undefined, {paddingLeft: 12}, {paddingLeft: 12})),
        title: "System Type",
        field: "systemType",
        editable: state.canEdit ? "always" : "never",
        emptyValue: "",
        initialEditValue: "",
        editComponent: (props) => {
          const comboValues = [{"code":"MCS","value":"Mcs"}];
          return (
            <Select
              style={{width: "100%"}}
              value={props.value == null?'':props.value}
              onChange={
                (evt, data) => {
                  props.onChange(data.props.value);
                }
              }
              renderValue={(value) => `${value}`}
            >
              {(comboValues) ? 
                comboValues.map((record) => {
                    return (
                      <MenuItem key={record.code} value={record.value}>{record.code} - {record.value}</MenuItem>
                    );
                }) :
                null
              }
            </Select>
          )
        }
      },
      {
        ...baseColumn,
        title: "Mapped Code",
        field: "mappedCode",
        initialEditValue: "",
        editComponent: (props) => (
          <MaskedText
            mask={"x".repeat(30)}
            maskChar={""}
            alwaysShowMask={false}
            formatChars={formatChars}
            value={props.value}
            onChange={props.onChange}
            inputProps={defaultEditProps}
          />
        )
      },
    ];
  };
  
  return (isAuthenticated &&
    <div style={{ marginLeft: 50 }}>
        <MaterialTable
            tableRef={tableRef}
            style={{
              backgroundColor: "#fdfdfd",
              border: "2px solid #aaaaaa",
              boxShadow: "none",
              borderRadius: 0,
            }}
            options={{
              actionsColumnIndex: -1,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle:{
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                color: theme.palette.childTableHeader.textColor,
                padding: "2px",
              },      
              toolbarButtonAlignment: "right",
              pageSize: 5,
              detailPanelType: "single",
            }}
            components={{
              ...defaultComponents,
              Pagination: (props) => (
                  <TablePagination
                      {...props}
                      rowsPerPageOptions={[5, 10, 15]}
                  />
              ),
            }}
            title="Sage Ledger Code Mapping Management"
            columns={getColumns({canEdit: state.canEdit})}
            data={sageLedgerCodeMappings.data}
            editable={{
              isEditable: () => {
                return state.canEdit;
              },
              isDeletable: () => {
                return state.canEdit;
              },
              onRowAdd: state.canEdit
                  ? (newData) => new Promise((resolve, reject) => {
                    handleAddSageLedgerCodeMapping.mutate({record: {...newData, sageLedgerCodeUuid: props.record.sageLedgerCodeUuid}, resolve, reject, extraKeys});
                  })
                  : undefined,
              onRowUpdate: (newData, oldData) =>
                  new Promise((resolve, reject) => {
                    handleUpdateSageLedgerCodeMapping.mutate({record: newData, oldRecord: oldData, resolve, reject, extraKeys});
                  }),
              onRowDelete: (oldData) =>
                  new Promise((resolve, reject) => {
                    handleDeleteSageLedgerCodeMapping.mutate({oldRecord: oldData, resolve, reject, extraKeys});
                  }),
            }}
        />
      </div>
  );

}

export default SageLedgerCodeMappingList;
